import _objectSpread from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _asyncToGenerator from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
import { scaleLinear, scaleLog, scaleQuantize } from 'd3-scale';
import { autorun } from 'mobx';
import { isAbortException, getSession, getContainingView } from '@jbrowse/core/util';
import { getRpcSessionId } from '@jbrowse/core/util/tracks';
import { addDisposer, isAlive } from 'mobx-state-tree';
import { getConf } from '@jbrowse/core/configuration';
export var YSCALEBAR_LABEL_OFFSET = 5;
/**
 * produces a d3-scale from arguments. applies a "nice domain" adjustment
 *
 * @param object - containing attributes
 *   - domain [min,max]
 *   - range [min,max]
 *   - bounds [min,max]
 *   - scaleType (linear or log)
 *   - pivotValue (number)
 *   - inverted (boolean)
 */
export function getScale(_ref) {
  var _ref$domain = _ref.domain,
    domain = _ref$domain === void 0 ? [] : _ref$domain,
    _ref$range = _ref.range,
    range = _ref$range === void 0 ? [] : _ref$range,
    scaleType = _ref.scaleType,
    pivotValue = _ref.pivotValue,
    inverted = _ref.inverted;
  var scale;
  var _domain = _slicedToArray(domain, 2),
    min = _domain[0],
    max = _domain[1];
  if (min === undefined || max === undefined) {
    throw new Error('invalid domain');
  }
  if (scaleType === 'linear') {
    scale = scaleLinear();
  } else if (scaleType === 'log') {
    scale = scaleLog();
    scale.base(2);
  } else if (scaleType === 'quantize') {
    scale = scaleQuantize();
  } else {
    throw new Error('undefined scaleType');
  }
  scale.domain(pivotValue !== undefined ? [min, pivotValue, max] : [min, max]);
  scale.nice();
  var _range = _slicedToArray(range, 2),
    rangeMin = _range[0],
    rangeMax = _range[1];
  if (rangeMin === undefined || rangeMax === undefined) {
    throw new Error('invalid range');
  }
  scale.range(inverted ? range.slice().reverse() : range);
  return scale;
}
/**
 * gets the origin for drawing the graph. for linear this is 0, for log this is arbitrarily set to log(1)==0
 *
 * @param scaleType -
 */
export function getOrigin(scaleType /* , pivot, stats */) {
  // if (pivot) {
  //   if (pivot === 'mean') {
  //     return stats.scoreMean || 0
  //   }
  //   if (pivot === 'zero') {
  //     return 0
  //   }
  //   return parseFloat()
  // }
  // if (scaleType === 'z_score') {
  //   return stats.scoreMean || 0
  // }
  if (scaleType === 'log') {
    return 1;
  }
  return 0;
}
/**
 * produces a "nice" domain that actually rounds down to 0 for the min
 * or 0 to the max depending on if all values are positive or negative
 *
 * @param object - containing attributes
 *   - domain [min,max]
 *   - bounds [min,max]
 *   - mean
 *   - stddev
 *   - scaleType (linear or log)
 */
export function getNiceDomain(_ref2) {
  var scaleType = _ref2.scaleType,
    domain = _ref2.domain,
    bounds = _ref2.bounds;
  var _bounds = _slicedToArray(bounds, 2),
    minScore = _bounds[0],
    maxScore = _bounds[1];
  var _domain2 = _slicedToArray(domain, 2),
    min = _domain2[0],
    max = _domain2[1];
  if (scaleType === 'linear') {
    if (max < 0) {
      max = 0;
    }
    if (min > 0) {
      min = 0;
    }
  }
  if (scaleType === 'log') {
    // if the min is 0, assume that it's just something
    // with no read coverage and that we should ignore it in calculations
    // if it's greater than 1 pin to 1 for the full range also
    // otherwise, we may see bigwigs with fractional values
    if (min === 0 || min > 1) {
      min = 1;
    }
  }
  if (min === undefined || max === undefined) {
    throw new Error('invalid domain supplied to stats function');
  }
  if (minScore !== undefined && minScore !== Number.MIN_VALUE) {
    min = minScore;
  }
  if (maxScore !== undefined && maxScore !== Number.MAX_VALUE) {
    max = maxScore;
  }
  var getScaleType = function getScaleType(type) {
    if (type === 'linear') {
      return scaleLinear();
    }
    if (type === 'log') {
      var _scale = scaleLog();
      _scale.base(2);
      return _scale;
    }
    if (type === 'quantize') {
      return scaleQuantize();
    }
    throw new Error("undefined scaleType ".concat(type));
  };
  var scale = getScaleType(scaleType);
  scale.domain([min, max]);
  scale.nice();
  return scale.domain();
}
export function groupBy(array, predicate) {
  return array.reduce(function (acc, value) {
    var _a;
    var entry = acc[_a = predicate(value)] || (acc[_a] = []);
    entry.push(value);
    return acc;
  }, {});
}
export function getStats(_x, _x2) {
  return _getStats.apply(this, arguments);
}
function _getStats() {
  _getStats = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(self, opts) {
    var _getSession, rpcManager, nd, adapterConfig, autoscaleType, sessionId, params, results, scoreMin, scoreMean, scoreStdDev, _getContainingView, dynamicBlocks, bpPerPx, _results, _scoreMin, _scoreMean, _scoreStdDev;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _getSession = getSession(self), rpcManager = _getSession.rpcManager;
          nd = getConf(self, 'numStdDev') || 3;
          adapterConfig = self.adapterConfig, autoscaleType = self.autoscaleType;
          sessionId = getRpcSessionId(self);
          params = _objectSpread({
            sessionId: sessionId,
            adapterConfig: adapterConfig,
            statusCallback: function statusCallback(message) {
              if (isAlive(self)) {
                self.setMessage(message);
              }
            }
          }, opts);
          if (!(autoscaleType === 'global' || autoscaleType === 'globalsd')) {
            _context2.next = 11;
            break;
          }
          _context2.next = 8;
          return rpcManager.call(sessionId, 'WiggleGetGlobalStats', params);
        case 8:
          results = _context2.sent;
          scoreMin = results.scoreMin, scoreMean = results.scoreMean, scoreStdDev = results.scoreStdDev; // globalsd uses heuristic to avoid unnecessary scoreMin<0
          // if the scoreMin is never less than 0
          // helps with most coverage bigwigs just being >0
          return _context2.abrupt("return", autoscaleType === 'globalsd' ? _objectSpread({}, results, {
            scoreMin: scoreMin >= 0 ? 0 : scoreMean - nd * scoreStdDev,
            scoreMax: scoreMean + nd * scoreStdDev
          }) : results);
        case 11:
          if (!(autoscaleType === 'local' || autoscaleType === 'localsd')) {
            _context2.next = 18;
            break;
          }
          _getContainingView = getContainingView(self), dynamicBlocks = _getContainingView.dynamicBlocks, bpPerPx = _getContainingView.bpPerPx;
          _context2.next = 15;
          return rpcManager.call(sessionId, 'WiggleGetMultiRegionStats', _objectSpread({}, params, {
            regions: dynamicBlocks.contentBlocks.map(function (region) {
              var start = region.start,
                end = region.end;
              return _objectSpread({}, JSON.parse(JSON.stringify(region)), {
                start: Math.floor(start),
                end: Math.ceil(end)
              });
            }),
            bpPerPx: bpPerPx
          }));
        case 15:
          _results = _context2.sent;
          _scoreMin = _results.scoreMin, _scoreMean = _results.scoreMean, _scoreStdDev = _results.scoreStdDev; // localsd uses heuristic to avoid unnecessary scoreMin<0 if the
          // scoreMin is never less than 0 helps with most coverage bigwigs
          // just being >0
          return _context2.abrupt("return", autoscaleType === 'localsd' ? _objectSpread({}, _results, {
            scoreMin: _scoreMin >= 0 ? 0 : _scoreMean - nd * _scoreStdDev,
            scoreMax: _scoreMean + nd * _scoreStdDev
          }) : _results);
        case 18:
          if (!(autoscaleType === 'zscale')) {
            _context2.next = 20;
            break;
          }
          return _context2.abrupt("return", rpcManager.call(sessionId, 'WiggleGetGlobalStats', params));
        case 20:
          throw new Error("invalid autoscaleType '".concat(autoscaleType, "'"));
        case 21:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _getStats.apply(this, arguments);
}
export function statsAutorun(self) {
  addDisposer(self, autorun( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var aborter, view, statsRegion, wiggleStats;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          aborter = new AbortController();
          view = getContainingView(self);
          self.setLoading(aborter);
          if (!(!view.initialized || !self.estimatedStatsReady || self.regionTooLarge)) {
            _context.next = 6;
            break;
          }
          return _context.abrupt("return");
        case 6:
          statsRegion = JSON.stringify(view.dynamicBlocks);
          _context.next = 9;
          return getStats(self, _objectSpread({
            signal: aborter.signal
          }, self.renderProps()));
        case 9:
          wiggleStats = _context.sent;
          if (isAlive(self)) {
            self.updateStats(wiggleStats, statsRegion);
          }
          _context.next = 16;
          break;
        case 13:
          _context.prev = 13;
          _context.t0 = _context["catch"](0);
          if (!isAbortException(_context.t0) && isAlive(self)) {
            console.error(_context.t0);
            self.setError(_context.t0);
          }
        case 16:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 13]]);
  })), {
    delay: 1000
  }));
}
export function toP() {
  var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return +(+s).toPrecision(6);
}
export function round(value) {
  return Math.round(value * 1e5) / 1e5;
}